import script from "./WeatherWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./WeatherWidget.vue?vue&type=script&setup=true&lang=ts"

import "./WeatherWidget.vue?vue&type=style&index=0&id=66cd1b9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66cd1b9c"]])

export default __exports__